import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import user from "../../images/user.png";
import axios from "axios";
import { API_URL } from "../../../config";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const DeleteAccount = () => {
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

  let query = useQuery();

  const [alerts, setAlerts] = useState("");
  const [loader, setLoader] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const navigate = useNavigate();

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordShown(!confirmPasswordShown);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlerts("");

    if (!query.get("token")) {
      return setAlerts("Invalid or missing token.");
    }

    if (email !== confirmEmail) {
      return setAlerts("Email do not match.");
    }
    if (password !== confirmPassword) {
      return setAlerts("Password do not match.");
    }

    // Show confirmation modal
    setConfirmModal(true);
  };

  const confirmDeleteAccount = async () => {
    setConfirmModal(false);
    setLoader(true);
    setErrorMessage("");
    setSuccessMessage("");

    try {
      const res = await axios.post(`${API_URL}/app/delete-account-confirm`, {
        email: email,
        password: password,
        token: query.get("token"),
      });

      setLoader(false);

      if (res.data.success) {
        setSuccessMessage(res.data.message || "Account deleted successfully.");
        setSuccessModal(true);

        // reset form fields
        setEmail("");
        setConfirmEmail("");
        setPassword("");
        setConfirmPassword("");

        // Redirect to login page after a delay
        setTimeout(() => {
          navigate("/login");
        }, 3000);

        localStorage.clear();
      } else {
        setErrorMessage(res.data.message || "Something went wrong.");
        setErrorModal(true);
      }
    } catch (err) {
      setLoader(false);
      const message =
        err.response?.data?.message ||
        err.message ||
        "There was a problem deleting your account.";
      setErrorMessage(message);
      setErrorModal(true);

      if (err.response?.status === 401) {
        // Redirect to login page after a delay
        setTimeout(() => {
          navigate("/login");
        }, 3000);

        localStorage.clear();
      }
    }
  };

  return (
    <div className="login-bg">
      <div className="wrp-login">
        <form onSubmit={handleSubmit}>
          <div className="login-content">
            <div className="login-database">
              <p style={{ fontWeight: "bold" }}>Delete Your Account</p>
            </div>
            {/* <div className="user-img">
              <img src={user} alt="user-img" />
            </div> */}
            <div className="wrp-label">
              <label>Email Address</label>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="wrp-label mrt-input">
              <label>Confirm Email Address</label>
              <input
                type="email"
                placeholder="Confirm Email"
                value={confirmEmail}
                onChange={(e) => setConfirmEmail(e.target.value)}
                required
              />
            </div>
            <div className="wrp-label mrt-input password-input">
              <label>Password</label>
              <input
                type={passwordShown ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {passwordShown ? (
                <i
                  className="fa fa-eye-slash pass-eye"
                  style={{ top: "38px" }}
                  onClick={togglePasswordVisibility}
                ></i>
              ) : (
                <i
                  className="fa fa-eye pass-eye"
                  style={{ top: "38px" }}
                  onClick={togglePasswordVisibility}
                ></i>
              )}
            </div>
            <div className="wrp-label mrt-input password-input">
              <label>Confirm Password</label>
              <input
                type={confirmPasswordShown ? "text" : "password"}
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              {confirmPasswordShown ? (
                <i
                  className="fa fa-eye-slash pass-eye"
                  style={{ top: "38px" }}
                  onClick={toggleConfirmPasswordVisibility}
                ></i>
              ) : (
                <i
                  className="fa fa-eye pass-eye"
                  style={{ top: "38px" }}
                  onClick={toggleConfirmPasswordVisibility}
                ></i>
              )}
            </div>
            {alerts && <p className="invalid-p">{alerts}</p>}

            <button className="login-btn" type="submit" disabled={loader}>
              Delete Account
              {loader && <div id="loader"></div>}
            </button>
          </div>
        </form>
      </div>

      {/* Confirmation Modal */}
      <Modal
        isOpen={confirmModal}
        toggle={() => setConfirmModal(!confirmModal)}
        centered
      >
        <ModalHeader toggle={() => setConfirmModal(!confirmModal)}>
          Confirm Account Deletion
        </ModalHeader>
        <ModalBody>
          <p>
            Are you sure you want to permanently delete your account? This
            action cannot be undone.
          </p>
          <div className="d-flex justify-content-end mt-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => setConfirmModal(false)}
            >
              Cancel
            </button>
            <button className="btn btn-danger" onClick={confirmDeleteAccount}>
              Yes, Delete
            </button>
          </div>
        </ModalBody>
      </Modal>

      {/* Success Modal */}
      <Modal
        isOpen={successModal}
        toggle={() => setSuccessModal(!successModal)}
        centered
      >
        <ModalHeader toggle={() => setSuccessModal(!successModal)}>
          Account Deleted
        </ModalHeader>
        <ModalBody>
          <p style={{ textAlign: "center", color: "green", padding: "1rem 0" }}>
            {successMessage}
          </p>
        </ModalBody>
      </Modal>

      {/* Error Modal */}
      <Modal
        isOpen={errorModal}
        toggle={() => setErrorModal(!errorModal)}
        centered
      >
        <ModalHeader toggle={() => setErrorModal(!errorModal)}>
          Error
        </ModalHeader>
        <ModalBody>
          <p style={{ textAlign: "center", color: "red" }}>{errorMessage}</p>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default DeleteAccount;
